module.exports = __webpack_public_path__ + "img/imagem-03-detalhada-palmeiras-01.3d177c97.png";